import { Button, Navigation } from "@monta/design-system";
import { useDaContext } from "../../context/descriptive/context";
import DesktopDescriptiveAnswerReportFilter from "./Desktop";
import MobileDescriptiveAnswerReportFilter from "./Mobile";
import styles from "./styles.module.scss";

type Props = {
  data: { label: string; value: string }[];
};

const DescriptiveAnswerReportFilter = (props: Props) => {
  const { data } = props;
  const { page, pageSize, setPage, total, setFilters } = useDaContext();

  return (
    <>
      <section className={styles["filter-desktop-container"]}>
        <DesktopDescriptiveAnswerReportFilter moduleGroupFilters={data} />
        <div className={styles["filter-desktop-container__delete-container"]}>
          <Navigation
            currentPage={page}
            onPageChange={setPage}
            pageSize={pageSize}
            totalCount={total}
          />
          <Button
            className={
              styles["filter-desktop-container__delete-container__delete"]
            }
            width={98}
            borderRadius="2"
            height={44}
            onClick={() => {
              setFilters({ selectedAnswerStatus: "all" });
              setPage(1);
            }}
          >
            حذف فیلترها
          </Button>
        </div>
      </section>
      <div className={styles["mobile-navigation"]}>
        <Navigation
          currentPage={page}
          onPageChange={setPage}
          pageSize={pageSize}
          totalCount={total}
        />
      </div>
      <MobileDescriptiveAnswerReportFilter moduleGroupFilters={data} />
    </>
  );
};

export default DescriptiveAnswerReportFilter;
